import { Controller } from "@hotwired/stimulus";

// Leaves a <video> unloaded until the user presses play, so the page never
// downloads clips nobody watches. Clicking again pauses. Starting one clip
// pauses every other lazy video, so only one plays at a time.
export default class extends Controller {
  static targets = ["video"];
  static values = { src: String };
  static classes = ["playing"];

  connect() {
    // A Turbo cache restore can bring the class back on a paused video.
    this.sync();
  }

  toggle() {
    const video = this.videoTarget;
    if (!video.getAttribute("src")) video.src = this.srcValue;

    if (video.paused) video.play().catch(() => {});
    else video.pause();
  }

  sync() {
    const playing = !this.videoTarget.paused;
    this.element.classList.toggle(this.playingClass, playing);
    if (playing) this.dispatch("play");
  }

  // Bound to lazy-video:play@window, which every instance dispatches.
  pauseOthers({ target }) {
    if (target !== this.element) this.videoTarget.pause();
  }
}
